import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const Login = ({ setToken }) => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [settings, setSettings] = useState({ cover: "", logo: "" });
  const handleCancel = () => {    
      navigate("/"); 
  };
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get("https://cardapio.olympicbarbacena.com.br/api/settings");
        setSettings(response.data);
      } catch (error) {
        console.error("Erro ao buscar configurações:", error);
      }
    };
    fetchSettings();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("https://cardapio.olympicbarbacena.com.br/api/login", {
        username: form.username,
        password: form.password,
      });

      const token = response.data.token; // Obtém o token da resposta
      setToken(token); // Atualiza o estado com o token
      localStorage.setItem("token", token); // Armazena o token no localStorage
    } catch (err) {
      setError("Credenciais inválidas");
      console.error("Erro ao fazer login:", err);
    }
  };

  return (
    <div className="login-container">
      {settings.logo && (
        <div className="logo-container">
          <img
            className="login-logo"
            src={`https://cardapio.olympicbarbacena.com.br${settings.logo}`}
            alt="Logo"
          />

        </div>
        )}
      <h2>Login</h2>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleSubmit} className="login-form">
        <input
          type="text"
          placeholder="Usuário"
          value={form.username}
          onChange={(e) => setForm({ ...form, username: e.target.value })}
          required
        />
        <input
          type="password"
          placeholder="Senha"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          required
        />
        <button type="submit" className="login-button">
          Entrar
        </button>
      </form>
      <div className="login-form">
        <button onClick={()=>handleCancel()} className="cancel-button">
          Voltar
        </button>

      </div>
    </div>
  );
};

export default Login;
